import React from "react";
import Lottie from "lottie-react";
import notfound from "../../assests/Animation.json"; // Ensure the path is correct

const NotFound = () => {
  return (
    <div className="d-flex justify-content-center">
      <Lottie animationData={notfound} loop={true} />
    </div>
  );
};

export default NotFound;
